import { useCallback, useMemo } from 'react';

import { useIntegrationsPage } from 'pages/Settings/integrations/hooks/useIntegrationsPage';

export const useIntegrationsForm = ({ network, linkedinSyncBasePath, linkedinSyncReturnTo, onGoogleSyncComplete }) => {
  const { googleSync, googleLogin, linkedinSync, hasGoogleSyncFeature } = useIntegrationsPage({
    network,
    onGoogleSyncComplete,
  });

  // Check connection status (null/undefined syncStatus means not connected)
  const isLinkedinConnected = !!linkedinSync?.syncStatus && linkedinSync.syncStatus !== 'not_connected';
  const isGoogleConnected = !!googleSync?.syncStatus && googleSync.syncStatus !== 'not_connected';

  // All integrations done = LinkedIn connected AND (Google feature disabled OR Google connected)
  const allIntegrationsDone = useMemo(
    () => isLinkedinConnected && (!hasGoogleSyncFeature || isGoogleConnected),
    [isLinkedinConnected, hasGoogleSyncFeature, isGoogleConnected],
  );

  // Any integration done = LinkedIn OR (Google feature enabled AND connected)
  const anyIntegrationDone = useMemo(
    () => isLinkedinConnected || (hasGoogleSyncFeature && isGoogleConnected),
    [isLinkedinConnected, hasGoogleSyncFeature, isGoogleConnected],
  );

  // Generate LinkedIn sync link with configurable base path and return URL
  const getLinkedinSyncLink = useCallback(
    (status = 'sync') => {
      const baseUrl = `${linkedinSyncBasePath}/${status}`;
      return linkedinSyncReturnTo ? `${baseUrl}?returnTo=${linkedinSyncReturnTo}` : baseUrl;
    },
    [linkedinSyncBasePath, linkedinSyncReturnTo],
  );

  return {
    googleSync,
    googleLogin,
    linkedinSync,
    hasGoogleSyncFeature,
    allIntegrationsDone,
    anyIntegrationDone,
    getLinkedinSyncLink,
  };
};
